import React from 'react';
import s from "./Contacts.module.css";
import bg from "../../../assets/img/contacts_bg.jpg"
import ContactUsForm from "../../../components/ContactUsForm/ContactUsForm";
import {Helmet} from "react-helmet-async";

const Contacts = () => {
    return (
        <div className={s.wrapper}>

            <Helmet>
                <title>Contact LuxPay digital banking & Payment Support</title>
                <meta
                    name="description"
                    content="Contact LuxPay for support with digital payments, IBAN accounts, SEPA & SEPA Instant
                    transfers, business or personal accounts, FX services, and general finance inquiries."
                />
                <meta name="keywords" content="LuxPay contact, digital banking support, SEPA payment support,
                IBAN account help"/>
            </Helmet>

            <div className={s.container}>
                <div className={s.form_wrapper}>
                    <div className={s.title}>
                        Contact Us
                    </div>
                    <ContactUsForm/>
                </div>
                <div className={s.bg}>
                    <img src={bg} alt=""/>
                </div>
            </div>

        </div>
    );
};

export default Contacts;
